import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import useRouteParams from './useRouteParams';
const useNavigation = () => {
  const history = useHistory();
  const {
    tabId,
    contentId,
    pageTypeSlug
  } = useRouteParams();
  const updateCurrentTab = useCallback(updatedSelection => {
    history.push(`/${pageTypeSlug}/${contentId}/${updatedSelection}`);
  }, [history, contentId, pageTypeSlug]);
  const updateCurrentPage = useCallback(updatedContentId => {
    history.push(`/${pageTypeSlug}/${updatedContentId}/${tabId}`);
  }, [history, tabId, pageTypeSlug]);
  return useMemo(() => ({
    tabId,
    updateCurrentTab,
    updateCurrentPage
  }), [tabId, updateCurrentTab, updateCurrentPage]);
};
export default useNavigation;